export const SYSTEM_CONFIG_QUERY_KEY_PREV_PAGE = "prev_page";
export const SYSTEM_CONFIG_QUERY_KEY_SELECTED_SYSTEM = "selected_system";
export const SYSTEM_CONFIG_QUERY_KEY_REFERER = "referer";
export const PATHNAME_KEY = "pathname";
